import { Typography } from '@mui/material';

const TooltipTypography = ({ children, ...props }) => (
  <Typography sx={{ fontSize: 12 }} {...props}>
    {children}
  </Typography>
);

export default TooltipTypography;
